import { IDENTITY_LOGOUT, IDENTITY_AUTHORIZE } from '@frontend/shared-defaults';
import { logout as logoutToExpireTokenPkce } from '../../integrations/auth-pkce';

// `keySuffix` is a generic, caller-provided storage-key namespace appended to the
// product name. Defaulting to '' keeps the canonical `${product}__access_token` key,
// so existing callers are unaffected. Callers that need an isolated session (e.g. a
// dedicated auth area) pass their own suffix without this lib knowing the concept.
const getSSKeyAccessToken = ({ keySuffix = '' } = {}) => {
  const productName = process.env.NX_PUBLIC_PRODUCT_NAME?.toLowerCase().replaceAll(' ', '_') || 'product';

  return `${productName}${keySuffix}__access_token`;
}

export const getAccessTokenFromStorage = ({ keySuffix = '' } = {}) =>
  sessionStorage.getItem(getSSKeyAccessToken({ keySuffix }));

export const removeAccessTokenInStorage = ({ keySuffix = '' } = {}) =>
  sessionStorage.removeItem(getSSKeyAccessToken({ keySuffix }));

export const setAccessTokenInStorage = (accessToken, { keySuffix = '' } = {}) =>
  sessionStorage.setItem(getSSKeyAccessToken({ keySuffix }), accessToken);

export const logout = async ({ isAuthPkce = false, logoutUrl = IDENTITY_LOGOUT, keySuffix = '' } = {}) => {
  if (isAuthPkce) {
    const accessToken = getAccessTokenFromStorage({ keySuffix });

    try {
      await logoutToExpireTokenPkce(accessToken);
    } catch (error) { /* */ }
  }
  removeAccessTokenInStorage({ keySuffix });
  window.location.assign(logoutUrl);
}

export const authorize = () => {
  window.location.assign(IDENTITY_AUTHORIZE);
}


